export default __webpack_public_path__ + "static/media/Nabil.b211e5f8.png";